import usePureState from '@/hooks/usePureState';
import { ILocationOptionEnum, ILocationQuestionOptions } from '@/types/IQuestion';
import { Box, Checkbox, Stack, Text } from '@chakra-ui/react';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

type IQuestionOptionsSection = {
	isLoading: boolean;
	value: ILocationQuestionOptions;
	onChange: (options: ILocationQuestionOptions) => void;
};

/**
 * This component handles the add / remove options on a question of type select.
 */
export default function QuestionOptionsSection(props: IQuestionOptionsSection) {
	const { t } = useTranslation();
	const { state, dispatch } = usePureState({ options: props.value });

	function handleChange(e: ChangeEvent<HTMLInputElement>) {
		const { id, checked } = e.target as { id: ILocationOptionEnum; checked: boolean };
		if (!checked) {
			const options = [...state.options.filter((o) => o.type !== id)];
			dispatch({ options });
			return props.onChange(options);
		}

		state.options.push({ type: id });

		dispatch({ options: [...state.options] });
		props.onChange([...state.options]);
	}

	return (
		<Box mt="3">
			<Text fontWeight="500">{t('Available options:')}</Text>
			<Stack mt="2" spacing={1} direction="column">
				<Checkbox
					isDisabled={props.isLoading}
					id="GoogleMeetLocationOption"
					defaultChecked={state.options.some((e) => e.type === 'GoogleMeetLocationOption')}
					checked={state.options.some((e) => e.type === 'GoogleMeetLocationOption')}
					onChange={handleChange}
				>
					{t('Video call using Google Meet')}
				</Checkbox>
				<Checkbox
					isDisabled={props.isLoading}
					id="MicrosoftOutlookLocationOption"
					defaultChecked={state.options.some((e) => e.type === 'MicrosoftOutlookLocationOption')}
					checked={state.options.some((e) => e.type === 'MicrosoftOutlookLocationOption')}
					onChange={handleChange}
				>
					{t('Video call using Microsoft Teams')}
				</Checkbox>
				<Checkbox
					isDisabled={props.isLoading}
					id="BookerPhoneLocationOption"
					defaultChecked={state.options.some((e) => e.type === 'BookerPhoneLocationOption')}
					checked={state.options.some((e) => e.type === 'BookerPhoneLocationOption')}
					onChange={handleChange}
				>
					{t('Phone call using booker phone number')}
				</Checkbox>
				<Checkbox
					isDisabled={props.isLoading}
					id="FixedLocationOption"
					defaultChecked={state.options.some((e) => e.type === 'FixedLocationOption')}
					checked={state.options.some((e) => e.type === 'FixedLocationOption')}
					onChange={handleChange}
				>
					{t('Physical')}
				</Checkbox>
			</Stack>
		</Box>
	);
}
